<template>
  <v-navigation-drawer
    app
    class="sidebar mx-auto"
    v-model="toggleSidebar"
  >
    <div class="sidebar__logo">
      <v-list dense nav class="sidebar__logo-list my-0 py-0">
        <v-list-item-avatar
          class="pa-1"
          max-width="52"
          width="100%"
          tile
        >
          <img src="../../assets/logo.svg" alt="evo" class="sidebar__logo-img">
        </v-list-item-avatar>
      </v-list>
    </div>
    <v-list dense nav class="sidebar__nav list-mobile pa-3">
      <router-link
        v-for="(link, index) in filteredLinks"
        :key="index"
        :href="`${link.path}`"
        :title="link.meta.title"
        :to="link.path"
        class="text-none sidebar__link"
      >
        <v-list-item
          v-if="$canRoute(link.name)"
          link
          class="sidebar__item"
          :style="link.meta.isLinks ? 'display: contents;' : ''"
          :class="{ 'sidebar__item--active': isActiveLink(link.path) }"
        >
          <template>
            <v-list-item-icon class="sidebar__icon mr-3">
              <v-icon size="18" tag="span">
                {{ link.meta.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content class="py-0 sidebar__label">
              {{ link.meta.title }}
            </v-list-item-content>
          </template>
        </v-list-item>
      </router-link>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppSidebar',
  data () {
    return {
      isUserLinksVisible: false,
      isLinksVisible: false,
    };
  },
  methods: {
    isActiveLink (path) {
      if (path === '/areas') {
        return this.$route.path === '/areas' || this.$route.path.startsWith('/areas/') || this.$route.path.startsWith('/mto-sector/');
      }
      return this.$route.path === path;
    },
    toggleLinksVisibility () {
      this.isLinksVisible = !this.isLinksVisible;
    },
    toggleUserLinksVisibility () {
      this.isUserLinksVisible = !this.isUserLinksVisible;
    },
  },
  computed: {
    ...mapGetters(['drawer']),
    toggleSidebar: {
      get () {
        return this.drawer;
      },
      set (value) {
        this.$store.commit('setDrawer', value);
      },
    },
    filteredLinks () {
      return this.$router.options.routes.filter(route => {
        return route.meta.auth === true;
      });
    },
    // filteredUserLinks () {
    //   return this.$router.options.routes.filter(route => {
    //     return route.meta.users === true;
    //   });
    // },
    // filteredDoorphoneLinks () {
    //   return this.$router.options.routes.filter(route => {
    //     return route.meta.isPacs === true;
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  max-width: 256px;
  width: 100%;
  background: linear-gradient(180deg, #21408D 0%, #1a2d6b 50%, #1C1654 100%);
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.15);
}

.sidebar__logo {
  min-height: 44px;
  padding: 0px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.sidebar__logo-list {
  height: 100%;
}

.sidebar__logo-img {
  width: 52px;
  height: 18px;
  filter: brightness(1.05);
}

.sidebar__nav {
  padding-top: 12px !important;
}

.sidebar__link {
  text-decoration: none;
  display: block;
  margin-bottom: 4px;
  border-radius: 10px;
  overflow: hidden;
}

.sidebar__item {
  border-radius: 10px;
  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.sidebar__item:hover {
  background-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateX(4px);
}

.sidebar__item--active {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  border-left: 3px solid rgba(255, 255, 255, 0.9);
}

.sidebar__item--active:hover {
  background: rgba(255, 255, 255, 0.18);
  transform: none;
}

.sidebar__icon {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  min-width: 18px !important;
  width: 18px;
  height: 18px;

  span {
    color: #ffffff;
  }
}

.sidebar__label {
  padding: 10px 0;
  color: #ffffff;
  font-family: "SF Pro Display", sans-serif;
  font-size: 15px;
  line-height: 1.35;
  font-weight: 500;
}

.sidebar ::v-deep .v-list-group__header__prepend-icon span {
  color: #ffffff;
}

.rotate-icon {
  transform: rotate(180deg);
  transition: transform 0.4s ease;
}
</style>

<style lang="scss">
.users {
  .v-list-item__icon.v-list-group__header__prepend-icon {
    margin-right: 14px;
    margin-left: 4px;
  }
  .v-list-group__header__append-icon {
    display: none;
  }
}
@media screen and (max-width: 800px) {
  .list-mobile {
    padding-bottom: 100px
  }
}
</style>
